import { Mixin, Mixins } from 'vue-mixin-decorator';

import WithSpinner from '@/shared/mixins/withSpinner.mixin.ts';

@Mixin
class WithPagination extends Mixins<WithSpinner>(WithSpinner) {
  protected nextPage: number | null = 1;
  protected activePage: number | null = 1;
  protected itemsPerPage = 50;
  protected totalItems = 0;
  protected seeAll = false;
  protected moreItemsPerPageMultiplier = 5; // 240 items per page when viewing more
  protected moreItemsPerPageShowed = false;
  protected tooManyTotalPagesThreshold = 100; // Until 560 items see all. From there view more
  protected offset = 0;
  protected limit = this.itemsPerPage;
  protected action: string | null = null;

  public fetchList(): void {
    // tslint:disable-next-line:no-console
    console.log('implement me!');
  }

  public onFetchSuccess(res: any) {
    this.totalItems = res.count;
    this.activePage = res.activePage || this.nextPage;
    this.action = res.action || this.action;
    this.limit = res.limit || this.limit;
    this.nextPage = null;
    if (this.action === 'all-items') {
      this.itemsPerPage = this.limit;
      this.seeAll = true;
    } else if (this.action === 'more-items') {
      this.itemsPerPage = this.limit;
      this.moreItemsPerPageShowed = true;
    } else if (this.action === 'less-items') {
      this.itemsPerPage = this.limit;
      this.moreItemsPerPageShowed = false;
    }
    this.changeSpinnerVisibility(false);
  }

  public fetchFirstPageList() {
    this.limit = this.itemsPerPage;
    this.offset = 0;
    this.nextPage = 1;
    this.fetchList();
  }

  public goItemPage(payload: any) {
    this.requestShowSpinner();
    this.nextPage = payload.page;
    this.offset = payload.offset;
    this.limit = this.itemsPerPage;
    this.action = null;
    this.fetchList();
  }

  public seeAllItems(payload: any) {
    this.requestShowSpinner();
    const limitValue = this.totalItems + 100;
    this.offset = 0;
    this.limit = limitValue;
    this.action = 'all-items';
    this.fetchList();
  }

  public moreItemsPerPage(payload: any) {
    this.requestShowSpinner();
    const limitValue = payload.multiplier * this.itemsPerPage;
    this.nextPage = payload.page;
    this.offset = 0;
    this.limit = limitValue;
    this.action = 'more-items';
    this.fetchList();
  }

  public lessItemsPerPage(payload: any) {
    this.requestShowSpinner();
    const limitValue = this.itemsPerPage / payload.divider;
    this.nextPage = payload.page;
    this.offset = 0;
    this.limit = limitValue;
    this.action = 'less-items';
    this.fetchList();
  }
}

export default WithPagination;
